import { render, staticRenderFns } from "./InvoiceDesc.vue?vue&type=template&id=c81c4436&scoped=true"
import script from "./InvoiceDesc.vue?vue&type=script&lang=ts"
export * from "./InvoiceDesc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81c4436",
  null
  
)

export default component.exports